import $ from 'jquery'

if (typeof window.hospitals !== 'undefined') {

  function departments(){
    return window.hospitals().find(h => h[0] == hospitalSelect.val())[1]
  }
  function patientGroups(){
    return departments().find(h => h[0]== departmentSelect.val())[1]
  }

  let hospitalSelect = $("#hospital")
  let departmentSelect = $("#department")
  let patientGroupSelect = $("#decision_helper_patient_group_id")

  for(let o of window.hospitals()){
    hospitalSelect.append(`<option value="${o[0]}">${o[0]}</option>`)
  }

  function updateDepartments(){
    departmentSelect.html("")
    for(let o of departments()){
      departmentSelect.append(`<option value="${o[0]}">${o[0]}</option>`)
    }
    updatePatientGroups()
  }

  function updatePatientGroups(){
    patientGroupSelect.html("")
    for(let o of patientGroups()){
      patientGroupSelect.append(`<option value="${o.server_id}">${o.name}</option>`)
    }
  }

  updateDepartments()
  hospitalSelect.change(updateDepartments);
  departmentSelect.change(updatePatientGroups);
}